// extracted by mini-css-extract-plugin
export default {"root":"styles_root__singr","header":"styles_header__VIejO","headText":"styles_headText__IYLd-","addButton":"styles_addButton__YnuFY"};